import { rem, transparentize } from "polished"
import styled, { css } from "styled-components"
import { theme } from "../../../util/styles/theme"

const inputBorderSize = rem(1)

export interface InputProps {
  error?: boolean
}

export const BaseInputStyles = css<InputProps>`
  appearance: none;
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.small};
  border: ${inputBorderSize} solid
    ${({ error }) => (error ? theme.colors.red : theme.colors.greyDark)};
  color: ${theme.colors.primary};
  outline: none;
  padding: calc(${theme.spacings.medium} - ${inputBorderSize})
    calc(${theme.spacings.small} - ${inputBorderSize});
  transition: border-color 0.3s;
  width: 100%;

  ::placeholder {
    color: ${transparentize(0.5, theme.colors.black)};
  }
`

export const BaseInput = styled.input<InputProps>`
  ${BaseInputStyles}
`

BaseInput.defaultProps = {
  error: false,
}
